<template>
  <pl-dialog maxWidth="600px" height="600px" :padding="'2em'" class="center-xs">
    <div style="position: absolute; right: 0; top: 0">
      <pl-button @click.native="$emit('close')" style="min-width: 0">
        <strong class="f4">X</strong>
      </pl-button>
    </div>
    <img :src="logo" style="height: 50px" />
    <div class="mt3 b f3">Select a Course Work</div>

    <div class="modal-body-container" style="height: 300px; margin-top: 20px">
      <div class="row col-xs no-margin center-xs select-classroom">
        <pl-select
          :options="courseWorks"
          label="title"
          :selected="selected_rt"
          :arrow="true"
          :placeholder="'Select a Course Work'"
          class="mb4"
          @change="selectCourseWork($event)"
        >
        </pl-select>
      </div>
    </div>
    <div class="row no-margin center-xs">
      <pl-button> BACK </pl-button>
      <pl-button
        :disabled="!selected_rt"
        @click.native="syncCourseWork"
        class="pl-primary"
      >
        NEXT
      </pl-button>
    </div>
  </pl-dialog>
</template>

<script>
  export default {
    data() {
      return {
        selected_rt: null,
      };
    },
    props: {
      courseWorks: {
        type: Array,
        default() {
          return [];
        },
      },
      edLink: {
        type: Boolean,
        required: true,
      },
      logo: {
        type: String,
        required: true,
      },
      activityType: {
        type: String,
        required: true,
      },
    },
    methods: {
      selectCourseWork(courseWork) {
        this.selected_rt = courseWork;
      },
      syncCourseWork() {
        if (!this.edLink) {
          const action =
            this.activityType === 'written'
              ? 'syncRTCourseWork'
              : 'syncLDCourseWork';
          this.$store.dispatch(action, {
            courseWorkID: this.selected_rt.id,
          });
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
  .pl-secondary
      color: #283248
</style>



// WEBPACK FOOTER //
// rtGoogleClassroomModal.vue?3cce4e4f